// Typing Speed Test Tool — measure typing speed (WPM) and accuracy.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";
import { TYPING_VARIANTS } from "./lib/variants";

export const typingSpeedTestTool: Tool = {
  id: "typing-speed-test",
  name: () => m.typing_tool_name(),
  description: () => m.typing_tool_description(),
  icon: "⌨️",
  basePath: "/typing-speed-test",
  status: "stable",
  tags: ["typing", "test", "wpm", "speed"],
  pages: [
    {
      name: () => m.typing_nav_main(),
      path: "/typing-speed-test",
      description: () => m.typing_nav_main_desc(),
      icon: "⌨️",
    },
    {
      name: () => TYPING_VARIANTS["1-minute-typing-test"].navName(),
      path: "/typing-speed-test/1-minute-typing-test",
      description: () => m.typing_nav_variant_desc(),
      icon: "⏱️",
    },
    {
      name: () => TYPING_VARIANTS["3-minute-typing-test"].navName(),
      path: "/typing-speed-test/3-minute-typing-test",
      description: () => m.typing_nav_variant_desc(),
      icon: "⏱️",
    },
    {
      name: () => TYPING_VARIANTS["5-minute-typing-test"].navName(),
      path: "/typing-speed-test/5-minute-typing-test",
      description: () => m.typing_nav_variant_desc(),
      icon: "⏱️",
    },
  ],
};
